var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-checklist-form-block",class:{
  invalid: _vm.invalid
}},[_c('div',{staticClass:"qrw-label-lg bold"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_vm._t("default"),(_vm.required)?_c('div',{staticClass:"required-label qrw-label-sm bold"},[_vm._v("\n        "+_vm._s(_vm.$t('checklist_report_blocks.required'))+"\n    ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }